'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var errcode = require('err-code');

var pTimeout = require('p-timeout');

var c = require('../constants');

var LimitedPeerList = require('../peer-list/limited-peer-list');

var Message = require('../message');

var Query = require('../query');

var utils = require('../utils');
/**
 * @typedef {import('multiformats/cid').CID} CID
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */

/**
 * @param {import('../')} dht
 */


module.exports = function (dht) {
  /**
   * Check for providers from a single node.
   *
   * @param {PeerId} peer
   * @param {CID} key
   *
   * @private
   */
  var findProvidersSingle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer, key) {
      var msg;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              msg = new Message(Message.TYPES.GET_PROVIDERS, key.bytes, 0);
              return _context.abrupt("return", dht.network.sendRequest(peer, msg));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function findProvidersSingle(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    /**
     * Announce to the network that we can provide the value for a given key
     *
     * @param {CID} key
     */
    provide: function provide(key) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var errors, multiaddrs, msg, mapPeer, _mapPeer;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _mapPeer = function _mapPeer3() {
                  _mapPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            dht._log("putProvider ".concat(key, " to ").concat(peer.toB58String()));

                            _context2.prev = 1;
                            _context2.next = 4;
                            return dht.network.sendMessage(peer, msg);

                          case 4:
                            _context2.next = 9;
                            break;

                          case 6:
                            _context2.prev = 6;
                            _context2.t0 = _context2["catch"](1);
                            errors.push(_context2.t0);

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[1, 6]]);
                  }));
                  return _mapPeer.apply(this, arguments);
                };

                mapPeer = function _mapPeer2(_x3) {
                  return _mapPeer.apply(this, arguments);
                };

                dht._log("provide: ".concat(key));
                /** @type {Error[]} */


                errors = []; // Add peer as provider

                _context3.next = 6;
                return dht.providers.addProvider(key, dht.peerId);

              case 6:
                multiaddrs = dht.libp2p ? dht.libp2p.multiaddrs : [];
                msg = new Message(Message.TYPES.ADD_PROVIDER, key.bytes, 0);
                msg.providerPeers = [{
                  id: dht.peerId,
                  multiaddrs: multiaddrs
                }];
                /**
                 * @param {PeerId} peer
                 */

                _context3.next = 11;
                return utils.mapParallel(dht.getClosestPeers(key.bytes), mapPeer);

              case 11:
                if (!errors.length) {
                  _context3.next = 13;
                  break;
                }

                throw errcode(new Error("Failed to provide to ".concat(errors.length, " of ").concat(dht.kBucketSize, " peers")), 'ERR_SOME_PROVIDES_FAILED', {
                  errors: errors
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Search the dht for up to `K` providers of the given CID.
     *
     * @param {CID} key
     * @param {Object} [options] - findProviders options
     * @param {number} [options.timeout=60000] - how long the query should maximally run, in milliseconds
     * @param {number} [options.maxNumProviders=5] - maximum number of providers to find
     * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>}
     */
    findProviders: function findProviders(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        timeout: 60000,
        maxNumProviders: 5
      };
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var providerTimeout, n, out, provs, _iterator, _step, pData, paths, makePath, query, peers, _iterator2, _step2, _pData;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                makePath = function _makePath(pathIndex, numPaths) {
                  // This function body runs once per disjoint path
                  var pathSize = utils.pathSize(n - out.length, numPaths);
                  var pathProviders = new LimitedPeerList(pathSize);
                  paths.push(pathProviders);
                  /**
                   * The query function to use on this particular disjoint path
                   *
                   * @param {PeerId} peer
                   */

                  function queryDisjointPath(_x4) {
                    return _queryDisjointPath.apply(this, arguments);
                  }

                  function _queryDisjointPath() {
                    _queryDisjointPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peer) {
                      var msg, provs;
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return findProvidersSingle(peer, key);

                            case 2:
                              msg = _context4.sent;
                              provs = msg.providerPeers;

                              dht._log("Found ".concat(provs.length, " provider entries for ").concat(key));

                              provs.forEach(function (prov) {
                                pathProviders.push(_objectSpread({}, prov));
                              }); // hooray we have all that we want

                              if (!(pathProviders.length >= pathSize)) {
                                _context4.next = 8;
                                break;
                              }

                              return _context4.abrupt("return", {
                                pathComplete: true
                              });

                            case 8:
                              return _context4.abrupt("return", {
                                closerPeers: msg.closerPeers
                              });

                            case 9:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));
                    return _queryDisjointPath.apply(this, arguments);
                  }

                  return queryDisjointPath;
                };

                providerTimeout = options.timeout || c.minute;
                n = options.maxNumProviders || c.K;

                dht._log("findProviders ".concat(key));

                out = new LimitedPeerList(n);
                _context5.next = 7;
                return _awaitAsyncGenerator(dht.providers.getProviders(key));

              case 7:
                provs = _context5.sent;
                provs.forEach(function (id) {
                  /** @type {{ id: PeerId, addresses: { multiaddr: Multiaddr }[] }} */
                  var peerData = dht.peerStore.get(id);

                  if (peerData) {
                    out.push({
                      id: peerData.id,
                      multiaddrs: peerData.addresses.map(function (address) {
                        return address.multiaddr;
                      })
                    });
                  } else {
                    out.push({
                      id: id,
                      multiaddrs: []
                    });
                  }
                }); // All done

                if (!(out.length >= n)) {
                  _context5.next = 28;
                  break;
                }

                // yield values
                _iterator = _createForOfIteratorHelper(out.toArray());
                _context5.prev = 11;

                _iterator.s();

              case 13:
                if ((_step = _iterator.n()).done) {
                  _context5.next = 19;
                  break;
                }

                pData = _step.value;
                _context5.next = 17;
                return pData;

              case 17:
                _context5.next = 13;
                break;

              case 19:
                _context5.next = 24;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5["catch"](11);

                _iterator.e(_context5.t0);

              case 24:
                _context5.prev = 24;

                _iterator.f();

                return _context5.finish(24);

              case 27:
                return _context5.abrupt("return");

              case 28:
                // need more, query the network

                /** @type {LimitedPeerList[]} */
                paths = [];
                /**
                 *
                 * @param {number} pathIndex
                 * @param {number} numPaths
                 */

                query = new Query(dht, key.bytes, makePath);
                peers = dht.routingTable.closestPeers(key.bytes, dht.kBucketSize);
                _context5.prev = 31;
                _context5.next = 34;
                return _awaitAsyncGenerator(pTimeout(query.run(peers), providerTimeout));

              case 34:
                _context5.next = 40;
                break;

              case 36:
                _context5.prev = 36;
                _context5.t1 = _context5["catch"](31);

                if (!(_context5.t1.name !== pTimeout.TimeoutError.name)) {
                  _context5.next = 40;
                  break;
                }

                throw _context5.t1;

              case 40:
                _context5.prev = 40;
                query.stop();
                return _context5.finish(40);

              case 43:
                // combine peers from each path
                paths.forEach(function (path) {
                  path.toArray().forEach(function (peer) {
                    out.push(peer);
                  });
                });
                _iterator2 = _createForOfIteratorHelper(out.toArray());
                _context5.prev = 45;

                _iterator2.s();

              case 47:
                if ((_step2 = _iterator2.n()).done) {
                  _context5.next = 53;
                  break;
                }

                _pData = _step2.value;
                _context5.next = 51;
                return _pData;

              case 51:
                _context5.next = 47;
                break;

              case 53:
                _context5.next = 58;
                break;

              case 55:
                _context5.prev = 55;
                _context5.t2 = _context5["catch"](45);

                _iterator2.e(_context5.t2);

              case 58:
                _context5.prev = 58;

                _iterator2.f();

                return _context5.finish(58);

              case 61:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[11, 21, 24, 27], [31, 36, 40, 43], [45, 55, 58, 61]]);
      }))();
    }
  };
};